module.exports = __webpack_public_path__ + "img/david.c39b9be4.jpg";